export let smiles = [
	'🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍒', '🥝',

	'🍆', '🥬', '🥦', '🥒', '🌶', '🍅', '🥕', '🫒', '🧄', '🧅', '🥔',

	'🥚', '🥨', '🥯', '🥐', '🥞', '🧇',

	'🍗', '🍖', '🥩', '🍔', '🌭', '🍟', '🍕', '🥪', '🥙', '🧆', '🌮',
	'🌯', '🫔', '🥗', '🫕', '🥘', '🍝', '🍜', '🍲', '🍛', '🍣', '🍱',
	'🍤', '🍙', '🍚', '🍘', '🍥',

	'🥮', '🍢', '🍡', '🍧', '🍨', '🍦', '🥧', '🧁', '🍰', '🎂', '🍮',
	'🍭', '🍬', '🍫', '🍿', '🍩', '🍪', '🌰',

	'🥫', '🫖', '☕️', '🍵', '🧃', '🥤', '🧋', '🍶', '🍺', '🍻', '🥂',
	'🍷', '🥃', '🍸', '🍹', '🧉', '🍾', '🧊',
]

